import Button from '../../Button/Button';
import styled from 'styled-components';

export const QuantityButton = styled(Button)`
  &&.ant-btn.ant-btn-icon-only {
    width: ${({ btnSize }) => (btnSize === 'small' ? '28px' : '36px')}!important;
    height: ${({ btnSize }) => (btnSize === 'small' ? '28px' : '36px')}!important;
  }

  ${({ className, btnSize, isProductDetails }) => {
    if (isProductDetails) {
      return `
        border: 1px solid #43a047;
        border-radius: 8px !important;
        background-color: #ffffff !important;
        span {
          color: #43a047;
          display: flex;
          justify-content: center;
        }
        :disabled {
          span {
            color: #D5D7D5 !important;
          }
          border: 1px solid #43a047 !important;
        }
        :hover,
        :focus,
        :active {
          &:not(:disabled) {
            opacity: 0.9;
          }
        }
      `;
    }
    if (className === 'minus') {
      return `
        border: 1px solid #ffffff;
        border-radius: 6px !important;
        span {
          color: #757D73 !important;
          display: flex;
          justify-content: center;
        }
        :disabled {
          span {
            color: #EAEBEA !important;
          }
          background: #FFFFFF !important;
          border: 1px solid #FFFFFF !important;
        }
    `;
    }
    return `
      border: 1px solid #43A047;
      border-radius: 6px !important;
      span {
        color: #ffffff;
        display: flex;
        justify-content: center;
        & > svg {
          width: ${btnSize === 'small' ? '1.3em' : '22.5px'}!important;
          height: ${btnSize === 'small' ? '1.3em' : '22.5px'}!important;
        }
      }
      && {
        background: #43A047;
      }
      :hover, :focus, :active {
        &:not(:disabled) {
          opacity: .7;
          border: 1px solid #43A047 !important;
          background: #43A047 !important;
        }
      }
      :disabled {
        span {
          color: rgba(0, 0, 0, 0.25);
        }
      }
    `;
  }};

  &.ant-btn-round {
    width: ${({ btnSize }) => (btnSize === 'small' ? '28px' : '36px')}!important;
    height: ${({ btnSize }) => (btnSize === 'small' ? '28px' : '36px')}!important;
    padding: 0 15px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  &:before {
    opacity: 0;
    background-color: #54a46e;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {
    padding-left: 20px;
  }

  &.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only)
    .anticon:not(:last-child) {
    margin-left: -9px;
  }
`;
